// Texty USP pásu v době akce na dopravu (benefitPromo.js, #322).
import { NBSP } from '../../modules/money.js';

export default {
  /** položka o dopravě: titulek z adminu „Doprava od 69 Kč" */
  shipTitleRe: /doprava\s+od\s+\d/i,
  /** „Doprava od 19 Kč" (cena už s měnou z money()) */
  promoTitle: (price) => 'Doprava od ' + price,
  /** „PPL na výdejní místo do 10 kg, akce do 25. 10." (datum s tečkou z promoDateLabel) */
  promoText: (carrier, maxKg, until) => carrier + ' na výdejní místo do ' + maxKg + NBSP + 'kg, akce do ' + until,
};
